import clsx from "clsx";
import type React from "react";
import Logo from "src/components/app/Logo/Logo";
import Button from "src/components/common/Button/Button";
import Link from "src/components/common/Link/Link";
import { useExtracted } from "#i18n";
import styles from "./AppHeader.module.scss";

export interface AppHeaderProps {
  children?: React.ReactNode;
  actions?: React.ReactNode;
  showSignIn?: boolean;
  registerHref?: string;
  className?: string;
}

const AppHeader = (props: AppHeaderProps) => {
  const translateMessage = useExtracted();
  const {
    children,
    actions,
    showSignIn = true,
    registerHref = "/portal?auth=login",
    className,
  } = props;

  return (
    <>
      <a className="skipLink" href="#main-content">
        {translateMessage("Skip to main content")}
      </a>
      <header className={clsx(styles.header, className)}>
        <div className={styles.container}>
          <Link href="/" className={styles.logo}>
            <Logo className="text-[1.5rem] sm:text-3xl" />
          </Link>

          {children ? (
            <div className={styles.navArea}>
              <nav aria-label={translateMessage("Main navigation")}>{children}</nav>
            </div>
          ) : (
            <div className={styles.navArea} />
          )}

          {(actions || showSignIn) && (
            <div className={styles.signInArea}>
              {actions}
              {showSignIn && (
                <Button href={registerHref} label={translateMessage("Get started")}>
                  {translateMessage("Get started")}
                </Button>
              )}
            </div>
          )}
        </div>
      </header>
    </>
  );
};

export default AppHeader;
